const ScrollContainer = ({ children, containerStyle, style, className }) => (
  <div
    style={{
      ...containerStyle,
      ...style,
    }}
    className={className}
  >
    {children}
  </div>
);

ScrollContainer.defaultProps = {
  className: 'scrollbar__container',
  containerStyle: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
};

export default ScrollContainer;
